import { SxProps, Theme } from '@mui/material';

export const titleSX: SxProps<Theme> = (theme) => ({
	textAlign: 'center',
	font: 'normal normal 800 40px/40px Open Sans',
	letterSpacing: '0px',
	lineHeight: { xs: '33px', sm: '40px' },
	color: '#2C2C2C',
	textTransform: 'uppercase',
	[theme.breakpoints.down('md')]: {
		textAlign: 'center',
	},
	[theme.breakpoints.down('sm')]: {
		textAlign: 'center',
		fontSize: 'var(--font-size-xl)',
	},
});

export const subtitleSX: SxProps<Theme> = {
	mt: '10px',
	px: '0px',
	font: 'normal normal normal 15px/30px Open Sans',
	color: '#2C2C2C',
	letterSpacing: '0px',
	lineHeight: { xs: '20px', sm: '20px' },
	textAlign: 'center',
};
